// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_CtK","cls2":"LoggedInDiscoveryPage-cls2_3Kt LoggedInDiscoveryPage-cls1_CtK"};